import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { ErrorMessage, SelfBookingAppointmentCoachAvailableDates, UrlParams } from 'types';
import { client } from 'utils/api-client';

interface IUseAppointmentTypesSelfBookingCoachAvailableDates {
  appointmentTypeId?: string;
  staffId?: string;
  month?: string;
  enabled?: boolean;
}

export default function useSelfBookingAppointmentCoachAvailableDates({
  appointmentTypeId,
  staffId,
  month,
  enabled = true,
}: IUseAppointmentTypesSelfBookingCoachAvailableDates): UseQueryResult<
  AxiosResponse<SelfBookingAppointmentCoachAvailableDates>,
  AxiosError<ErrorMessage>
> {
  const queryFn = (): Promise<AxiosResponse<SelfBookingAppointmentCoachAvailableDates>> => {
    const params: UrlParams = {};

    if (staffId) {
      params.staff_id = staffId;
    }
    if (month) {
      params.month = month;
    }

    return client.get(`appointment-self-booking/${appointmentTypeId}/coach-available-dates/`, {
      params,
    });
  };

  return useQuery(
    ['appointment-type-self-booking-coach-available-dates', appointmentTypeId, staffId, month, enabled],
    queryFn,
    {
      enabled: enabled && !!appointmentTypeId && !!staffId && !!month,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
  );
}
